import { request } from "./api";

export type AdminSecuritySettings = {
  idle_lock_minutes: number;
  trust_days: number;
  unlock_max_failures: number;
};

export type AdminDevice = {
  id: string;
  name: string;
  userAgent: string | null;
  lastIp: string | null;
  lastActiveAt: string | null;
  trustedAt: string | null;
  expiresAt: string | null;
  locked: boolean;
  isCurrent: boolean;
};

export type UnlockResponse = {
  access_token: string;
  refresh_token: string;
  role: "admin" | "student";
  access_expires_at: number;
  idle_expires_at?: number | null;
  idle_lock_minutes?: number | null;
  is_super_admin?: boolean;
  permissions?: string[];
};

export const adminDevicesApi = {
  unlock: (refresh_token: string, password: string) =>
    request<UnlockResponse>("/auth/admin/unlock", {
      method: "POST",
      body: JSON.stringify({ refresh_token, password }),
    }),

  list: (token: string) =>
    request<{ devices: AdminDevice[]; settings: AdminSecuritySettings }>("/auth/admin/devices", {}, token),

  revoke: (id: string, token: string) =>
    request<{ ok: boolean }>(`/auth/admin/devices/${id}`, { method: "DELETE" }, token),

  logoutEverywhere: (token: string) =>
    request<{ ok: boolean; devices: number; sessions: number }>(
      "/auth/admin/logout-everywhere",
      { method: "POST" },
      token,
    ),

  saveSettings: (body: Partial<AdminSecuritySettings>, token: string) =>
    request<AdminSecuritySettings>(
      "/auth/admin/security-settings",
      { method: "PUT", body: JSON.stringify(body) },
      token,
    ),
};
